// src/hooks/useAppDispatch.js
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../store'; // Adjusted the path to the correct store file

const useAppDispatch: () => AppDispatch = useDispatch;

export default useAppDispatch;